import { AUTH_PUBLIC_PATHS } from "./config.js";

const PUBLIC_SET = new Set<string>(AUTH_PUBLIC_PATHS);

/** Rotas públicas de autenticação (fora do AppShell). */
export function isAuthPublicPath(pathname: string): boolean {
  const path = pathname.split("?")[0] ?? pathname;
  return PUBLIC_SET.has(path);
}

/**
 * Sanitiza returnUrl: só path relativo interno, sem loops para rotas de auth.
 */
export function sanitizeReturnUrl(raw: string | null | undefined): string {
  if (!raw || typeof raw !== "string") return "/";
  let decoded = raw;
  try {
    decoded = decodeURIComponent(raw);
  } catch {
    return "/";
  }
  if (!decoded.startsWith("/") || decoded.startsWith("//")) return "/";
  if (decoded.includes("://")) return "/";
  const pathOnly = decoded.split("?")[0] ?? decoded;
  if (isAuthPublicPath(pathOnly)) return "/";
  return decoded;
}

export function buildLoginPath(opts?: {
  returnUrl?: string;
  reason?: "expired" | "logout";
}): string {
  const params = new URLSearchParams();
  const returnUrl = sanitizeReturnUrl(opts?.returnUrl);
  if (returnUrl !== "/") {
    params.set("returnUrl", returnUrl);
  }
  if (opts?.reason === "expired") {
    params.set("reason", "expired");
  }
  const qs = params.toString();
  return qs ? `/login?${qs}` : "/login";
}

/** Evita redirecionar /login → /login?returnUrl=/login… */
export function shouldRedirectAuthenticatedAwayFromAuth(pathname: string): boolean {
  return isAuthPublicPath(pathname);
}
